const state = {
  lang: "en",
  langs: [
    { value: "ku", name: "kurdish" },
    { value: "ar", name: "arabic" },
    { value: "en", name: "english" }
  ],
  session: {},
  authenticated: false
};

const getters = {
  lang: state => state.lang,
  langs: state => state.langs,
  session: state => state.session,
  authenticated: state => state.authenticated
};

const actions = {
  changeLanguage({ commit }, newLang) {
    commit("changeLanguage", newLang);
  },
  createSession({ commit }, user) {
    commit("createSession", user);
  }
};

const mutations = {
  changeLanguage: (state, newLang) => {
    state.lang = newLang;
  },
  createSession: (state, user) => {
    if (user && user.username) {
      state.session = user;
      state.authenticated = true;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
